exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-border{border:0\n}\n.icon-group{display:inline-block\n}\n.table.b-table.b-table-stacked>tbody>tr>[data-label]::before{text-align:left\n}\n.card{height:100%;width:100%\n}\n.force-center{text-align:center !important\n}\n.border-3{border-width:3px !important\n}\ni:hover:before{height:42px;color:#ff1493\n}\n.VueCarousel-navigation{padding:0\n}\n.top-left{position:absolute;top:5px;left:20px;z-index:2;color:#000;background:rgba(255,255,255,.7);padding:5px\n}", ""]);

// exports
